/** Where Integrations › Google Analytics lives: the registry entry and every link to it read this. */
export const GA4_INTEGRATION_ROUTE = '/integrations/google-analytics'
